import { RouteObject } from "react-router-dom";
import { FreeTrialPage } from "./ui/FreeTrialPage";

export const freeTrialRoute: RouteObject = {
  path: "/free-trial",
  element: <FreeTrialPage />,
};
